import { render, staticRenderFns } from "./voteFromTo.vue?vue&type=template&id=64793bd6&scoped=true"
import script from "./voteFromTo.vue?vue&type=script&lang=js"
export * from "./voteFromTo.vue?vue&type=script&lang=js"
import style0 from "./voteFromTo.vue?vue&type=style&index=0&id=64793bd6&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64793bd6",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/data/actions-runner/_work/treasurenet-tnservices-servicesplatform-fe/treasurenet-tnservices-servicesplatform-fe/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('64793bd6')) {
      api.createRecord('64793bd6', component.options)
    } else {
      api.reload('64793bd6', component.options)
    }
    module.hot.accept("./voteFromTo.vue?vue&type=template&id=64793bd6&scoped=true", function () {
      api.rerender('64793bd6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/governance/components/voteFromTo.vue"
export default component.exports